// Import CSS
import "./ToggleSwitch.css";

/**
 * ToggleSwitch Component
 * 
 * A reusable toggle switch UI element for boolean input.
 * Accepts an optional label and secondary label, which are displayed 
 * on either side of the switch depending on the `labelPosition`.
 */

/** 
 * Example Usage (Single Label):
 * 
 * <ToggleSwitch
 *   name="notifications"
 *   value={true}
 *   onChange={handleChange}
 *   label="Notifications"
 *   labelPosition="right"
 * />
 * 
 * Example Usage (Dual Label):
 * 
 * <ToggleSwitch
 *   name="darkMode"
 *   value={false}
 *   onChange={handleChange}
 *   label="Dark"
 *   secondaryLabel="Light"
 *   labelPosition="left"
 * />
 */


const ToggleSwitch = ({
    
    // Name attribute for the checkbox input
    name,

    // Current checked state (default false)
    value = false,

    // Callback when the switch is toggled
    onChange,

    // Primary label text
    label = "",

    // CSS classname for label
    labelClassName,

    // Optional secondary label text
    secondaryLabel = "",

    // "left" or "right" — where the primary label appears
    labelPosition = "left",

    // If true, disables interaction
    disabled = false,

    // Optional tooltip text
    title,

    // Size variant: "s", "m", or "l"
    size = "m"

}) => {
	
    // Determine if the primary label is placed on the left
    const isLabelLeft = labelPosition === "left";
    
	
	
    return (
	
        // Wrapper div with size class and optional disabled class
        <div className={`switch-wrapper-${size} ${disabled ? "disabled" : ""}`}>
            
            {/* Outer label element to group switch and text */}
            <label className="switch-label">
                
                {/* Render main label on left if labelPosition is "left" */}
                {isLabelLeft && label && <span className="switch-text">{label}</span>}
                
                {/* Render secondary label on left if labelPosition is "right" */}
                {!isLabelLeft && secondaryLabel && <span className="switch-text">{secondaryLabel}</span>}

                {/* Switch toggle container */}
                <div className={`switch-toggle ${size}`} title={title}>
                    
                    {/* Checkbox input controls the switch state */}
                    <input
                        type="checkbox"
                        name={name}
                        checked={!!value}
                        onChange={(e) =>
                            onChange({
                                target: {
                                    name,
                                    value: e.target.checked,
                                },
                            })
                        }
                        disabled={disabled}
                    />
                    
                    {/* Slider element for styling the switch */}
                    <span className={`slider ${size} ${disabled ? "slider-disabled" : ""}`} />
                </div>

                {/* Render main label on right if labelPosition is "right" */}
                {!isLabelLeft && label && <span className={`switch-text ${labelClassName}`}>{label}</span>}
                
                {/* Render secondary label on right if labelPosition is "left" */}
                {isLabelLeft && secondaryLabel && <span className="switch-text">{secondaryLabel}</span>}
				
            </label>
			
        </div>
		
    );
	
};

export default ToggleSwitch;
